import '@ant-design/compatible/assets/index.css';
import { useQuery } from 'react-query';
import React, { useEffect } from 'react';

import { DatePicker, Input, Row } from 'antd';
import DF from 'DisplayFramework';
import { FormInstance } from 'antd/lib/form';
import { isNil } from 'lodash';
import { getAssetUsersListByAssetid } from 'services/assets';
import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';
import { useGetAssetDetails } from 'pages/Asset/AssetDetail/useGetAssetDetails';
import AssetUsersSelect from 'components/AssetUsersSelect';

export type TabAddAssetUseProps = {
  objectid: number;
  form: FormInstance;
  setSuccessful: any;
};

const TabVehicleExitAuthorization = ({
  objectid,
  form,
  setSuccessful,
}: TabAddAssetUseProps) => {
  const { data, refetch } = useGetAssetDetails(objectid, 'PROD');

  const { data: users, refetch: refetchUsers } = useQuery(
    ['getAssetUsersListByAssetid', { assetid: Number(data?.assetid) }],
    () =>
      getAssetUsersListByAssetid({ assetid: Number(data?.assetid) }).then(
        (res) => res.list || []
      ),
    { enabled: !!data?.assetid }
  );

  useEffect(() => {
    if (!isNil(data)) {
      form.setFieldsValue({
        event: 'TabVehicleExitAuthorization',
        assetusers: form.getFieldValue('assetusers'),
        departuredate: form.getFieldValue('departuredate'),
        dropoffdate: form.getFieldValue('dropoffdate'),
        destination: form.getFieldValue('destination'),
        comment: form.getFieldValue('comment'),
      });
    }
  }, [form, data]);

  return (
    <DF.Provider pagcode="tabvehicleexitauthorization">
      <Row gutter={24}>
        <FormInput labelCol={{ span: 8 }} col xs={6} name="assetusers">
          <AssetUsersSelect assetid={data?.assetid ?? 0} selectedRowKeys />
        </FormInput>
        <FormInput labelCol={{ span: 8 }} col xs={6} name="destination" rules={[{ required: true }]}>
          <Input />
        </FormInput>
      </Row>
      <Row gutter={24}>
        
        <FormInput labelCol={{ span: 8 }} col xs={6} rules={[{ required: true }]} name="dropoffdate">
          <DatePicker format="YYYY-MM-DD" />
        </FormInput>
        <FormInput labelCol={{ span: 8 }} col xs={6} rules={[{ required: true }]} name="departuredate">
          <DatePicker format="YYYY-MM-DD" />
        </FormInput>
        
      </Row>

      <Row gutter={[8, 8]}>
        <FormInput col xs={18} name="comment" rules={[{ required: true }]}>
          <TextArea rows={4} />
        </FormInput>
      </Row>
    </DF.Provider>
  );
};
export default TabVehicleExitAuthorization;
